/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import React, { forwardRef, useImperativeHandle, useState, useEffect } from "react";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDTypography from "components/MDTypography";
import {
  SolicitudesBorradas,
  EliminarSolicitud,
} from "../../../store/solicitudes/solicitudesActions";
import { useDispatch } from "react-redux";
import Loading from "components/loading";
import { MaterialReactTable, MRT_ActionMenuItem } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import Icon from "@mui/material/Icon";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import MDBox from "components/MDBox";

const SolcitudesBorradas = forwardRef(({ columns, esExpediente }, ref) => {
  const [expanded, setExpanded] = useState(false);
  const [cargandoDatos, setcargandoDatos] = useState(false);
  const [datos, setDatos] = useState([]);
  const dispatch = useDispatch();

  const consultar = async () => {
    setcargandoDatos(true);
    const respuesta = await dispatch(SolicitudesBorradas(esExpediente));
    if (respuesta.code === "Ok") {
      setDatos(respuesta.data);
    }
    setcargandoDatos(false);
  };

  const eliminar = async (row) => {
    await dispatch(EliminarSolicitud(row, false));
    consultar();
  };

  const handleAccordionChange = (event, isExpanded) => {
    setExpanded(isExpanded);
    if (isExpanded) {
      consultar(); // Llama al consultar interno
    }
  };

  // 👉 Exponer función al padre
  useImperativeHandle(ref, () => ({
    ejecutarConsulta: () => {
      consultar();
    },
  }));

  return (
    <div>
      <Accordion
        sx={{ background: "transparent" }}
        expanded={expanded}
        onChange={handleAccordionChange}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon color="warning" />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <MDTypography variant="button" color="text" fontWeight="regular">
            {esExpediente ? "Expedientes eliminados" : "Solicitudes eliminados"}
          </MDTypography>
        </AccordionSummary>
        <AccordionDetails>
          {cargandoDatos ? (
            <Loading title="Procesando por favor espere" />
          ) : datos.length === 0 ? (
            <MDBox textAlign="center">
              <MDTypography variant="button" color="text" fontWeight="regular">
                Sin resultados
              </MDTypography>
            </MDBox>
          ) : (
            <MaterialReactTable
              columns={columns}
              data={datos}
              localization={MRT_Localization_ES}
              initialState={{
                density: "compact",
                columnPinning: {
                  left: ["mrt-row-expand", "mrt-row-select"],
                  right: ["mrt-row-actions"],
                },
              }}
              muiTableHeadProps={{
                sx: { display: "table-header-group" },
              }}
              paginationDisplayMode="pages"
              muiPaginationProps={{
                sx: {
                  // Estilo general del componente de paginación
                  "& .MuiPaginationItem-root": {
                    color: "#FFFFFF", // Color de todos los números de página
                  },
                  "& .Mui-selected": {
                    fontWeight: "bold",
                    color: "#F58020", // Color del texto seleccionado
                  },
                },
              }}
              muiTableBodyCellProps={({ row, cell }) => ({
                sx: {
                  color:
                    cell.column.id === "precandidato"
                      ? row.original.leido
                        ? "#FFFFFF"
                        : "#F58020"
                      : "#FFFFFF",
                  opacity:
                    cell.column.id === "precandidato" ? (row.original.leido ? "0.7" : "1") : "0.7",
                  fontWeight:
                    cell.column.id === "precandidato"
                      ? row.original.leido
                        ? "normal"
                        : "bold"
                      : "normal",
                  fontSize: 12,
                },
              })}
              muiTableHeadCellProps={{
                sx: { color: "#FFFFFF", fontSize: 12 },
              }}
              icons={{
                SearchIcon: () => <Icon color="primary">search</Icon>,
                SearchOffIcon: () => <Icon color="primary">search_off</Icon>,
                CloseIcon: () => <Icon color="primary">close</Icon>,
                FullscreenIcon: () => <Icon color="primary">fullscreen</Icon>,
                FullscreenExitIcon: () => <Icon color="primary">fullscreen_exit</Icon>,
                FilterAltIcon: () => <Icon color="primary">search</Icon>,
                FilterListIcon: () => <Icon color="primary">filter_list</Icon>,
                FilterListOffIcon: () => <Icon color="primary">filter_list_off</Icon>,
                DensitySmallIcon: () => <Icon color="primary">density_small</Icon>,
                DensityMediumIcon: () => <Icon color="primary">density_medium</Icon>,
                DensityLargeIcon: () => <Icon color="primary">density_large</Icon>,
                FirstPageIcon: () => <Icon color="primary">first_page</Icon>,
                LastPageIcon: () => <Icon color="primary">last_page</Icon>,
                ChevronLeftIcon: () => <Icon color="primary">navigate_before</Icon>,
                ChevronRightIcon: () => <Icon color="primary">navigate_next</Icon>,
                MoreVertIcon: () => <Icon color="primary">more_vert</Icon>,
                MoreHorizIcon: () => <Icon color="primary">more_horiz</Icon>,
                SortIcon: () => <Icon color="primary">sort</Icon>,
                ClearAllIcon: () => <Icon color="primary">clear_all</Icon>,
                VisibilityOffIcon: () => <Icon color="primary">visibility_off</Icon>,
                ViewColumnIcon: () => <Icon color="primary">view_column</Icon>,
                SyncAltIcon: () => <Icon color="primary">import_export</Icon>,
                ArrowDownwardIcon: () => <Icon color="primary">import_export</Icon>,
                ArrowRightIcon: () => <Icon color="primary">import_export</Icon>,
              }}
              enableRowActions={true}
              renderRowActionMenuItems={({ row, table }) => [
                <MRT_ActionMenuItem
                  icon={<CheckCircleOutlineIcon color="success" />}
                  key="activar"
                  label={"Activar ".concat(esExpediente ? "Expediente" : "Solicitud")}
                  onClick={() => eliminar(row.original)}
                  table={table}
                />,
              ]}
            />
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
});

export default SolcitudesBorradas;
